export const en = {
    "k_6fb558f5": "Failed to open editor: Missing application ID or page ID parameter",
    "k_cd065d21": "Failed to open editor: page does not exist",
    "k_a2c36ef2": "Create offline tasks",
    "k_62e08b15": "Delete offline tasks",
    "k_870042dc": "Create offline configurations",
    "k_2ff967f1": "Update offline configuration",
    "k_183bdc94": "Delete offline configuration",
    "k_18a7c2a3": "Debugging offline configuration",
    "k_b47396e6": "WUJI AI function call failed",
    "k_6362e219": "Intelligent parsing of API documents",
    "k_5e4b1170": "Resolution failure",
    "k_42030fd8": "The analysis is complete, please confirm what you want to use",
    "k_3e4d3d3b": "Paste the API document below to automatically fill in the interface configuration",
    "k_4d069d64": "Inaccurate results? You can adjust the input and parse it again.",
    "k_e05f90f6": "Parsing",
    "k_4244c878": "Please paste in the HTTP API description document (including address, parameter description, etc.) without format requirements",
    "k_815ead9": "Please post it into the API document",
    "k_5711bfb0": "Domain name",
    "k_204a8af5": "Path",
    "k_fdf83a6f": "Response type",
    "k_a89cabc6": "Query parameter",
    "k_8ac45484": "Body parameter",
    "k_64529138": "//Set request header",
    "k_7e78ae76": "Path parameters",
    "k_2cba109": "//Interpolate and replace parameter {arg_0} in URL",
    "k_86494cc3": "Nothing was parsed. The following is the original response:\n\n{arg_0}",
    "k_21da6064": "The analysis has been completed. Please confirm the result",
    "k_3f2b2c69": "API document parsing error",
    "k_2580b15": "Applied, pay attention to check debugging parameters",
    "k_1af84802": "This function is not open yet. Please contact the administrator to open it",
    "k_a765637d": "The recipient, subject or content is empty, please check",
    "k_c1767c7": "Robot ID or message content cannot be empty",
    "k_a6543aad": "The message content has incorrect format. Please pass in valid JSON",
    "k_7fbdc837": "Message recipient cannot be blank",
    "k_a8f78fff": "Message content cannot be empty",
    "k_8d2306ed": "Customer account messages only support text and Markdown",
    "k_ac7aa0b1": "Incorrect configuration of text card message",
    "k_5f4086f5": "Target branch:",
    "k_abcc76ad": "Merge branches:",
    "k_5d2b94": "Invalid YAML format",
    "k_58c7fc17": "Invalid JSON format",
    "k_5bf0cfa1": "There are still {arg_0} unresolved conflicts",
    "k_36b0947e": "{arg_0} format verification failed",
    "k_53299515": ", row {arg_0}, column {arg_1}",
    "k_743cd779": "After resolving the following conflicts",
    "k_47b9d88": "Conflict has been resolved, click the \"Resolved\" button to mark it as resolved",
    "k_9f4c05a": "Conflicts resolved. Click \"Resolved\" to update the status",
    "k_722f2bb5": "Conflict to be resolved",
    "k_cb2316e1": "Resolved",
    "k_dce404e9": "Loading code......",
    "k_9da91dca": "Respond to conflict",
    "k_c3a416ea": "Conflict unresolved",
    "k_ef55ab6f": "Codes have been merged",
    "k_b67c3745": "Branch merge: {arg_0} → {arg_1}",
    "k_cff22f3a": "Branch merged",
    "k_d9bc4f74": "Please resolve all conflicts first",
    "k_21f67470": "[MergeModal] Failed to get branch name:",
    "k_d8fd8b86": "[MergeModal] Failed to initialize change data:",
    "k_f10de695": "AI editor is not ready yet",
    "k_191b4dad": "Timed out waiting for AI editor to save",
    "k_3781cdf2": "Saved successfully but no project information returned",
    "k_6e133be7": "AI editor save failed",
    "k_2c142eaa": "Failed to save AI project, please retry: {arg_0}",
    "k_bf2170b7": "Parent page requested merge save failed:",
    "k_e4fdcd4f": "[{arg_0}] Data merge failed. Please check whether there are still unresolved conflicts",
    "k_8b5d9d15": "Intelligence development",
    "k_d3a0f925": "Personal AI usage",
    "k_35db4ccf": "Enterprise AI usage",
    "k_2eea10d2": "Deploy AI usage",
    "k_3112ecbd": "Determine to use",
    "k_f2c81f4b": "Search environment",
    "k_8c98ac18": "Unmatched environment",
    "k_3e19f854": "The approval I initiated",
    "k_c1ad9dc5": "The AI returned content is not legal JSON:\n\n{arg_0}",
    "k_d515a191": "You are the HTTP API document parsing assistant. Extract the interface configuration from the API description or request code. Just output a JSON object, no markdown code blocks, no explanatory text.",
    "k_5f19f440": "Default proxy",
    "k_c8b3e950": "File Worker error:",
    "k_d97d79e": "Worker returned error:",
    "k_68b75749": "List view",
    "k_c59ad37d": "Tree view",
    "k_89dfa6fb": "Review view",
    "k_ca71a54e": "Missing necessary version information",
    "k_2e68944b": "Failed to load file, please try again",
    "k_532f379d": "Switch views",
    "k_3699bfd2": "Switch code change views",
    "k_f1f96a69": "No document changes",
    "k_b1546e5a": "Code change ({arg_0})",
    "k_ee5ecc61": "Drag to adjust width",
    "k_63b38a6b": "Please select a file to view details",
    "k_ab4dad4a": "Online version",
    "k_e8b499ed": "Collapse file directory",
    "k_f7803405": "Expand the file directory",
    "k_7b9a18b9": "Expand folder",
    "k_d27548a7": "Collapse folder",
    "k_c68232f2": "Switch to single column mode",
    "k_3467c439": "Switch to dual column mode",
    "k_693a56b4": "Click to copy the full commit id",
    "k_aa982dcc": "Copy commit {arg_0}",
    "k_a8a55532": "[MergeView] Failed to parse AI project before YAML:",
    "k_bf01a9f5": "[MergeView] Failed to parse AI project after YAML:",
    "k_1e6c906f": "Submission versions are different, but the document content is consistent",
    "k_4ce8da47": "Departure confirmation",
    "k_58dc3fac": "Decided to leave",
    "k_ce3f3f": "Think again",
    "k_62977224": "Checking differences with master",
    "k_4b1e7d17": "Confirm whether the current branch is pending submission, and then open the merge panel",
    "k_2055a827": "The master cannot integrate himself",
    "k_a23a9e5": "The merge target is the master. Please open this page from the functional branch.",
    "k_885858f9": "No submissions pending consolidation",
    "k_b0630294": "There are no mergeable differences between the current branch and the master.",
    "k_ce5fb2aa": "Integrated into master",
    "k_1b44f88": "Branch changes have been written to the master.",
    "k_7007826e": "Multiple branches are not opened",
    "k_164f5196": "The current application does not open multiple branches and cannot be merged.",
    "k_f7daf3b6": "Missing merge parameters",
    "k_274d2de7": "Please bring projectid and branch before entering this page.",
    "k_13383026": "Consolidation failed to complete",
    "k_e09d7ed0": "Merge failed. Please try again later",
    "k_503d4924": "The merge has not been submitted. Please re-enter this page to continue the merge",
    "k_7c072e6d": "Merge branches",
    "k_8bd2f536": "Unknown branch",
    "k_45a10094": "Enter the workbench"
};
